import InsertInvitationRoundedIcon from '@mui/icons-material/InsertInvitationRounded';

export default InsertInvitationRoundedIcon;
